import React, { useEffect } from "react";
import Select from "react-select";
import {
  BlurWrapper,
  FloatLabel,
  customStylesForMultiSelect,
} from "../../Utils/CustomComponent";
import { useSelector } from "react-redux";

const UseLenderSelect = ({
  title,
  field,
  register,
  setValue,
  watch,
  error,
  isMulti = false,
  disable,
}) => {
  const accountOptions = useSelector((state) => state.account.accountOptions);
  const value = watch(field);

  useEffect(() => {
    register(field);
  }, [field, register]);

  return (
    <div>
      <FloatLabel
        label={title}
        value={watch(field)}
        className={
          error?.length && (value === undefined || !value?.length)
            ? "text-error"
            : ""
        }
      >
        <BlurWrapper>
          <Select
            name={field}
            placeholder=""
            isMulti={isMulti}
            options={accountOptions}
            value={watch(field)}
            onChange={(selected) => {
              setValue(field, selected);
            }}
            styles={customStylesForMultiSelect}
            className={
              error?.length && (value === undefined || !value?.length)
                ? "is-invalid"
                : ""
            }
            isDisabled={disable}
          />
        </BlurWrapper>
        <div className="invalid-feedback">{error}</div>
      </FloatLabel>
    </div>
  );
};

export default UseLenderSelect;
